
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Navigate, useNavigate, useOutletContext, useParams } from "react-router-dom";
import { homePageActions } from "../../store/reducer/home";
import { Autocomplete, Box, Button, Card, CircularProgress, Container, Divider, Grid, IconButton, Modal, TextField, Typography, useTheme } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from 'dayjs';
import { gameNameList, gameNumberInputList, singlePanaBulkMapping, doublePanaBulkMapping, triplePanaMapping, findSPMotorPanas, findDPMotorPanas } from "../gameplay/gameConstants";
import AlertBar from "../../components/AlertBar";
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Close, Delete } from "@mui/icons-material";
import { styled, css } from '@mui/system';
import { Modal as BaseModal } from '@mui/base/Modal';
import CustomModal from "../../components/CustomModal";
import { authActions } from "../../store/reducer/auth-reducer";
import { starlineActions } from "../../store/reducer/starline";

const formFields: any = {
    date: { label: "Choose Date", field: 'date', value: '' },
    // session: { label: "Choose Session", field: 'radio', value: ['Open', 'Close'] },
    points: { label: "Enter Points", field: 'text', value: '' },
    open: { label: "Digits", field: 'autocomplete', value: '' },
}

const formFieldsBulk: any = {
    date: { label: "Choose Date", field: 'date', value: '' },
    points: { label: "Points per Number *", field: 'text', value: '', placeholder: 'Enter points' },
}

const formFieldsAllSPDPTP: any = {
    date: { label: "Choose Date", field: 'date', value: '' },
    points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
    panaType: { label: "Select Game Type", field: 'radio', value: ['SP', 'DP', 'TP'] },
    digit: { label: "Enter Single Digit", field: 'text', value: '', placeholder: 'Enter digit (0-9)' },
}

const formFieldsSPMotor: any = {
    date: { label: "Choose Date", field: 'date', value: '' },
    points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
    digits: { label: "Enter Single Digit", field: 'text', value: '', placeholder: 'Enter digits (e.g., 1234)' },
}

const formFieldsDPMotor: any = {
    date: { label: "Choose Date", field: 'date', value: '' },
    points: { label: "Enter Points", field: 'text', value: '', placeholder: 'Enter points' },
    digits: { label: "Enter Digits (e.g., 1234)", field: 'text', value: '', placeholder: 'Enter 3 or more digits' },
}

const StarLinePlaceBid = ({
    isStarLineLoading,
    starLineData,
    starLineGameRateData,
    isStarLineGameRateFailed,
    starLineGameStatusActiveInactiveData,
    isStarLineGameStatusActiveInactiveFailed,
    isStarLineGameStatusActiveInactiveSuccess,
    isSubmitStarLineBidSuccess,
    isSubmitStarLineBidFailed,
    starLineMsg }: any) => {
    const outletdata: any = useOutletContext();
    const userDataSession: any = localStorage.getItem('userData');
    const finalData = JSON.parse(userDataSession);
    const theme = useTheme();
    const navigate = useNavigate();
    const newDate = dayjs();
    const pageParams = useParams<any>();
    const [open, setOpen] = useState(false);
    const { gamename } = useParams<any>();
    const [date_from, setDateFrom] = useState<Dayjs | null>(dayjs(new Date()));
    const [statusData, setStatusData] = useState<any>({ open_time: '', close_time: '' })
    const [routeData, setRouteData] = useState<any>({})
    const [payloadData, setPayload] = useState<any>({})
    const [gameRates, setGameRates] = useState<any>({
        "single_digit_val_1": "",
        "single_digit_val_2": "",
        "jodi_digit_val_1": "",
        "jodi_digit_val_2": "",
        "single_pana_val_1": "",
        "single_pana_val_2": "",
        "double_pana_val_1": "",
        "double_pana_val_2": "",
        "tripple_pana_val_1": "",
        "tripple_pana_val_2": "",
        "half_sangam_val_1": "",
        "half_sangam_val_2": "",
        "full_sangam_val_1": "",
        "full_sangam_val_2": "",
    })
    const [inputValue, setInputValue] = useState('');
    const [autoInputValue, setAutoInputValue] = useState('');
    const [errorMessage, setErrorMessage] = useState<any>({ status: false, message: '', severity: '', inputName: '' })
    const [formData, setFormData] = useState<any>({
        // session: '',
        open: '',
        points: '',
        digit: '',
        panaType: 'SP',
        digits: '' // For SP Motor (game type 12)
    })
    
    // Bulk mode selected digits (for game type 8 - Single Digit Bulk)
    const [selectedBulkDigits, setSelectedBulkDigits] = useState<Set<string>>(new Set());
    
    // Bulk mode selected pana digits (for game type 9 - Single Pana Bulk)
    const [selectedBulkPanaDigits, setSelectedBulkPanaDigits] = useState<Set<string>>(new Set());
    
    // Bulk mode selected double pana digits (for game type 10 - Double Pana Bulk)
    const [selectedBulkDoublePanaDigits, setSelectedBulkDoublePanaDigits] = useState<Set<string>>(new Set());
    
    // For game type 11 (All SP DP TP) - selected pana type and digit
    const [selectedPanaType, setSelectedPanaType] = useState<string>('SP'); // SP, DP, or TP

    // Exact valid lists for validation (as per user requirements)
    const validSinglePanaList = [
        '127', '136', '145', '190', '235', '280', '370', '389', '460', '479', '569', '578',
        '128', '137', '146', '236', '245', '290', '380', '470', '489', '560', '579', '678',
        '129', '138', '147', '156', '237', '246', '345', '390', '480', '570', '589', '679',
        '120', '139', '148', '157', '238', '247', '256', '346', '490', '580', '670', '689',
        '130', '149', '158', '167', '239', '248', '257', '347', '356', '590', '680', '789',
        '140', '159', '168', '230', '249', '258', '267', '348', '357', '456', '690', '780',
        '123', '150', '169', '178', '240', '259', '268', '349', '358', '367', '457', '790',
        '124', '160', '278', '179', '250', '269', '340', '359', '368', '458', '467', '890',
        '125', '134', '170', '189', '260', '279', '350', '369', '468', '378', '459', '567',
        '126', '135', '180', '234', '270', '289', '360', '379', '450', '469', '478', '568'
    ];
    
    const validDoublePanaList = [
        '118', '226', '244', '299', '334', '488', '550', '668', '677',
        '100', '119', '155', '227', '335', '344', '399', '588', '669',
        '110', '200', '228', '255', '336', '499', '660', '688', '778',
        '166', '229', '300', '337', '355', '445', '599', '779', '788',
        '112', '220', '266', '338', '400', '446', '455', '699', '770',
        '113', '122', '177', '339', '366', '447', '500', '799', '889', '555',
        '600', '114', '277', '330', '448', '466', '556', '880', '899',
        '115', '133', '188', '223', '377', '449', '557', '566', '700',
        '116', '224', '233', '288', '440', '477', '558', '800', '990',
        '117', '144', '199', '225', '388', '559', '577', '667', '900'
    ];
    
    const validTriplePanaList = [
        '000', '777', '444', '111', '888', '555', '222', '999', '666', '333'
    ];

    const [resultData, setResultData] = useState<any>([])
    const dispatch = useDispatch();

    useEffect(() => {
        const _gamename: any = gamename;
        const name: any = gameNameList[_gamename]
        dispatch(starlineActions.setMenuHeaderName(name));
        const pay: any = {
            menuname: 'starlineplacebid'
        }
        dispatch(homePageActions.selectedMenu(pay))
    }, [gamename])


    useEffect(() => {
        const gamePayload: any = {
            app_key: "@34Y@#8deepmatka"
        };
        dispatch(starlineActions.starLineDataReq(gamePayload))

        const data: any = {
            app_key: "@34Y@#8deepmatka",
            game_id: pageParams.game_id
        };
        dispatch(starlineActions.starLineGameRatesReq(data))
        dispatch(starlineActions.starLineGameStatusActiveInactiveReq(data))
        setRouteData(pageParams)
    }, [pageParams])

    useEffect(() => {
        if (starLineGameStatusActiveInactiveData) {
            setStatusData(starLineGameStatusActiveInactiveData);
        }
    }, [starLineGameStatusActiveInactiveData])


    useEffect(() => {
        if (starLineGameRateData) {
            if (Object.keys(starLineGameRateData).length > 0) {
                setGameRates(starLineGameRateData?.game_rates[0])
            }

        }
    }, [starLineGameRateData])

    const handleChange = (event: any, name: any) => {
        setFormData((prev: any) => {
            return { ...prev, [name]: event.target.value }
        })
    }

    // Handle bulk digit selection (for game type 8)
    const handleBulkDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkDigits((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(digit)) {
                newSet.delete(digit);
                // Remove from resultData
                setResultData((prevData: any) => prevData.filter((bid: any) => bid.digits !== digit));
            } else {
                newSet.add(digit);
                // Add to resultData (starline always uses 'Open' session)
                const newBid = {
                    points: formData.points,
                    session: 'Open',
                    digits: digit,
                    closedigits: '',
                };
                setResultData((prevData: any) => [...prevData, newBid]);
            }
            return newSet;
        });
    }

    // Handle bulk pana digit selection (for game type 9 - Single Pana Bulk)
    const handleBulkPanaDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkPanaDigits((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(digit)) {
                // Remove digit - remove all pana numbers for this digit
                newSet.delete(digit);
                const panaNumbers = singlePanaBulkMapping[digit] || [];
                setResultData((prevData: any) => 
                    prevData.filter((bid: any) => !panaNumbers.includes(bid.digits))
                );
            } else {
                // Add digit - add all pana numbers for this digit
                newSet.add(digit);
                const panaNumbers = singlePanaBulkMapping[digit] || [];
                const newBids = panaNumbers.map((pana: string) => ({
                    points: formData.points,
                    session: 'Open',
                    digits: pana,
                    closedigits: '',
                }));
                setResultData((prevData: any) => {
                    // Remove any existing bids that might conflict, then add new ones
                    const filtered = prevData.filter((bid: any) => !panaNumbers.includes(bid.digits));
                    return [...filtered, ...newBids];
                });
            }
            return newSet;
        });
    }

    // Handle bulk double pana digit selection (for game type 10 - Double Pana Bulk)
    const handleBulkDoublePanaDigitToggle = (digit: string) => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        setSelectedBulkDoublePanaDigits((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(digit)) {
                // Remove digit - remove all pana numbers for this digit
                newSet.delete(digit);
                const panaNumbers = doublePanaBulkMapping[digit] || [];
                setResultData((prevData: any) => 
                    prevData.filter((bid: any) => !panaNumbers.includes(bid.digits))
                );
            } else {
                // Add digit - add all pana numbers for this digit
                newSet.add(digit);
                const panaNumbers = doublePanaBulkMapping[digit] || [];
                const newBids = panaNumbers.map((pana: string) => ({
                    points: formData.points,
                    session: 'Open',
                    digits: pana,
                    closedigits: '',
                }));
                setResultData((prevData: any) => {
                    // Remove any existing bids that might conflict, then add new ones
                    const filtered = prevData.filter((bid: any) => !panaNumbers.includes(bid.digits));
                    return [...filtered, ...newBids];
                });
            }
            return newSet;
        });
    }

    // Handle ADD BID for game type 11 (All SP DP TP) - Starline version
    const handleAddBidAllSPDPTP = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digit || formData.digit === '' || !/^[0-9]$/.test(formData.digit)) {
            setErrorMessage({ status: true, message: 'Please enter a valid single digit (0-9)!', severity: 'warning', inputName: '' });
            return;
        }

        const digit = formData.digit;
        let panaNumbers: string[] = [];

        // Get pana numbers based on selected type
        if (selectedPanaType === 'SP') {
            panaNumbers = singlePanaBulkMapping[digit] || [];
        } else if (selectedPanaType === 'DP') {
            panaNumbers = doublePanaBulkMapping[digit] || [];
        } else if (selectedPanaType === 'TP') {
            panaNumbers = triplePanaMapping[digit] || [];
        }

        if (panaNumbers.length === 0) {
            setErrorMessage({ status: true, message: `No ${selectedPanaType} pana numbers found for digit ${digit}!`, severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all pana numbers for the selected digit and type
        const newBids = panaNumbers
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: 'Open',
                digits: pana,
                closedigits: '',
                gameType: selectedPanaType, // Store the game type for display
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} ${selectedPanaType} pana number(s) for digit ${digit}!`, severity: 'success', inputName: '' });
            // Clear digit input after adding
            setFormData((prev: any) => ({ ...prev, digit: '' }));
        } else {
            setErrorMessage({ status: true, message: `All ${selectedPanaType} pana numbers for digit ${digit} are already added!`, severity: 'info', inputName: '' });
        }
    }

    // Handle ADD BID for game type 12 (SP Motor) - Starline version
    const handleAddBidSPMotor = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digits || formData.digits === '' || formData.digits.replace(/[^0-9]/g, '').length < 3) {
            setErrorMessage({ status: true, message: 'Please enter at least 3 digits (e.g., 1234)!', severity: 'warning', inputName: '' });
            return;
        }

        // Find all valid Single Pana combinations from input digits
        const matchingPanas = findSPMotorPanas(formData.digits);

        if (matchingPanas.length === 0) {
            setErrorMessage({ status: true, message: 'No valid Single Pana numbers found for the entered digits!', severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all matching pana numbers
        const newBids = matchingPanas
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: 'Open',
                digits: pana,
                closedigits: '',
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} Single Pana number(s) for digits ${formData.digits.replace(/[^0-9]/g, '')}!`, severity: 'success', inputName: '' });
            // Clear digits input after adding
            setFormData((prev: any) => ({ ...prev, digits: '' }));
        } else {
            setErrorMessage({ status: true, message: `All Single Pana numbers for digits ${formData.digits.replace(/[^0-9]/g, '')} are already added!`, severity: 'info', inputName: '' });
        }
    }

    // Handle ADD BID for game type 13 (DP Motor) - Starline version
    const handleAddBidDPMotor = () => {
        if (!formData.points || formData.points === '') {
            setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            return;
        }

        if (!formData.digits || formData.digits === '' || formData.digits.replace(/[^0-9]/g, '').length < 3) {
            setErrorMessage({ status: true, message: 'Please enter at least 3 digits (e.g., 1234)!', severity: 'warning', inputName: '' });
            return;
        }

        // Find all valid Double Pana combinations from input digits
        const matchingPanas = findDPMotorPanas(formData.digits);

        if (matchingPanas.length === 0) {
            setErrorMessage({ status: true, message: 'No valid Double Pana numbers found for the entered digits!', severity: 'warning', inputName: '' });
            return;
        }

        // Get current bid digits to avoid duplicates
        const currentBidDigits = new Set(resultData.map((bid: any) => bid.digits));
        
        // Add all matching pana numbers
        const newBids = matchingPanas
            .filter((pana: string) => !currentBidDigits.has(pana))
            .map((pana: string) => ({
                points: formData.points,
                session: 'Open',
                digits: pana,
                closedigits: '',
            }));

        if (newBids.length > 0) {
            setResultData((prevData: any) => [...prevData, ...newBids]);
            setErrorMessage({ status: true, message: `Added ${newBids.length} Double Pana number(s) for digits ${formData.digits.replace(/[^0-9]/g, '')}!`, severity: 'success', inputName: '' });
            // Clear digits input after adding
            setFormData((prev: any) => ({ ...prev, digits: '' }));
        } else {
            setErrorMessage({ status: true, message: `All Double Pana numbers for digits ${formData.digits.replace(/[^0-9]/g, '')} are already added!`, severity: 'info', inputName: '' });
        }
    }

    // Auto input handler for single digit, single pana, double pana, triple pana (similar to regular games)
    const handleAutoInput = (e: any) => {
        let value = e.target.value;
        
        // Filter out non-digit and non-comma characters - only allow digits (0-9) and commas
        value = value.replace(/[^0-9,]/g, '');
        
        // Check if points are entered first (only show warning, don't clear input)
        if (!formData.points || formData.points === '') {
            // Still allow typing, just show warning
            setAutoInputValue(value);
            if (value.length > 0) {
                setErrorMessage({ status: true, message: 'Please enter points first!', severity: 'warning', inputName: '' });
            }
            return;
        }

        const minBidAmount = outletdata?.walletBalance?.min_bid_amount || 10;
        if (parseInt(formData.points) < minBidAmount) {
            // Still allow typing, just show warning
            setAutoInputValue(value);
            if (value.length > 0) {
                setErrorMessage({ status: true, message: `Minimum points is ${minBidAmount}`, severity: 'warning', inputName: '' });
            }
            return;
        }

        // Always update input value first for real-time typing feedback
        setAutoInputValue(value);

        // Get expected digits based on game type
        let expectedDigits = 1;
        if (gameidname === '1') expectedDigits = 1; // Single Digit
        else if (gameidname === '3' || gameidname === '4' || gameidname === '5') expectedDigits = 3; // Pana types

        // Extract only digits from input (allow comma for display)
        const digitsOnly = value.replace(/[^0-9]/g, '');
        
        // Get valid numbers from exact lists
        let validNumberSet = new Set<string>();
        if (gameidname === '1') {
            // Single Digit: 0-9 (all valid)
            validNumberSet = new Set(['0', '1', '2', '3', '4', '5', '6', '7', '8', '9']);
        } else if (gameidname === '3') {
            // Single Pana: exact list
            validNumberSet = new Set(validSinglePanaList);
        } else if (gameidname === '4') {
            // Double Pana: exact list
            validNumberSet = new Set(validDoublePanaList);
        } else if (gameidname === '5') {
            // Triple Pana: exact list
            validNumberSet = new Set(validTriplePanaList);
        }
        
        // Handle backspace/deletion - check if user is deleting
        const previousValue = autoInputValue.replace(/,\s*$/, '');
        const currentValue = value.replace(/,\s*$/, '');
        const previousDigitsOnly = previousValue.replace(/[^0-9]/g, '');
        
        // If user is deleting digits, handle removal
        if (digitsOnly.length < previousDigitsOnly.length && resultData.length > 0) {
            // Calculate how many entries should remain
            const remainingEntriesCount = Math.floor(digitsOnly.length / expectedDigits);
            if (remainingEntriesCount < resultData.length) {
                // Remove excess bids
                const newBids = resultData.slice(0, remainingEntriesCount);
                setResultData(newBids);
                
                // Rebuild input value from remaining bids + any incomplete input
                const displayValue = newBids.map((bid: any) => bid.digits).join(',');
                const incompleteInput = digitsOnly.substring(remainingEntriesCount * expectedDigits);
                setAutoInputValue(displayValue ? (displayValue + (incompleteInput ? ',' + incompleteInput : ',')) : incompleteInput);
                if (remainingEntriesCount < resultData.length) {
                    setErrorMessage({ status: true, message: 'Last bid removed!', severity: 'info', inputName: '' });
                }
                return;
            }
        }
        
        // Process ALL complete entries from the input at once
        const allEntries: string[] = [];
        for (let i = 0; i <= digitsOnly.length - expectedDigits; i += expectedDigits) {
            const entry = digitsOnly.substring(i, i + expectedDigits);
            if (entry.length === expectedDigits) {
                allEntries.push(entry);
            }
        }
        
        // Calculate incomplete input (digits after all complete entries)
        const completeEntriesLength = allEntries.length * expectedDigits;
        const incompleteInput = digitsOnly.substring(completeEntriesLength);
        
        // Get current bids to avoid duplicates
        const currentBidDigits = resultData.map((bid: any) => bid.digits);
        const newBids: any[] = [];
        const addedEntries: string[] = [];
        
        // Process each entry
        const invalidEntries: string[] = [];
        for (const nextEntry of allEntries) {
            // Skip if already in bids
            if (currentBidDigits.includes(nextEntry)) {
                continue;
            }
            
            // Validation - check if number exists in valid numbers list
            let isValid = false;
            let validationError = '';
            
            if (gameidname === '1') {
                // Single Digit - check if 0-9 (all are valid)
                if (nextEntry.length === 1 && /^[0-9]$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                } else {
                    validationError = `Invalid Single Digit: ${nextEntry}. Must be 0-9.`;
                }
            } else if (gameidname === '3') {
                // Single Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Single Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Single Pana: ${nextEntry}. Must be 3 digits.`;
                }
            } else if (gameidname === '4') {
                // Double Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Double Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Double Pana: ${nextEntry}. Must be 3 digits.`;
                }
            } else if (gameidname === '5') {
                // Triple Pana - must be in exact valid list only
                if (nextEntry.length === 3 && /^[0-9]{3}$/.test(nextEntry)) {
                    isValid = validNumberSet.has(nextEntry);
                    if (!isValid) {
                        validationError = `Invalid Triple Pana: ${nextEntry}. Not in valid list.`;
                    }
                } else {
                    validationError = `Invalid Triple Pana: ${nextEntry}. Must be 3 digits.`;
                }
            }
            
            if (isValid) {
                const newBid = {
                    points: formData.points,
                    session: 'Open',
                    digits: nextEntry,
                    closedigits: '',
                };
                newBids.push(newBid);
                addedEntries.push(nextEntry);
            } else if (validationError) {
                invalidEntries.push(validationError);
            }
        }
        
        // Add all new valid bids at once
        if (newBids.length > 0) {
            const updatedBids = [...resultData, ...newBids];
            setResultData(updatedBids);
            
            // Build the display value: all added bids + incomplete input with comma
            const displayValue = updatedBids.map((bid: any) => bid.digits).join(',');
            setAutoInputValue(displayValue + (incompleteInput ? ',' + incompleteInput : ','));
            
            let message = `Added ${addedEntries.length} number(s): ${addedEntries.join(', ')}`;
            if (invalidEntries.length > 0) {
                message += `. Invalid: ${invalidEntries.slice(0, 2).join(', ')}${invalidEntries.length > 2 ? '...' : ''}`;
            }
            
            setErrorMessage({ 
                status: true, 
                message: message, 
                severity: invalidEntries.length > 0 ? 'warning' : 'success', 
                inputName: '' 
            });
        } else if (invalidEntries.length > 0 && allEntries.length > 0) {
            // Only invalid entries - show error, keep existing bids, show incomplete input
            const existingBidsDisplay = resultData.map((bid: any) => bid.digits).join(',');
            setAutoInputValue(existingBidsDisplay + (existingBidsDisplay ? ',' : '') + (incompleteInput || ''));
            setErrorMessage({ 
                status: true, 
                message: invalidEntries.slice(0, 3).join('. '), 
                severity: 'error', 
                inputName: '' 
            });
        } else {
            // No new bids and no invalid entries - show existing bids + incomplete input
            const existingBidsDisplay = resultData.map((bid: any) => bid.digits).join(',');
            if (existingBidsDisplay) {
                setAutoInputValue(existingBidsDisplay + (incompleteInput ? ',' + incompleteInput : ','));
            } else {
                // No existing bids, just show what user typed
                setAutoInputValue(value);
            }
        }
    }

    useEffect(() => {

        const keys = Object.keys(gameRates);
        if (keys.length > 0) {
            console.log(keys, gameNameList[routeData.gamename])
            let temp: any = [];
            console.log(gameNameList[routeData.gamename])
            if (gameNameList[routeData.gamename]) {
                keys.forEach((item: any) => {
                    if (item.search(gameNameList[routeData.gamename].replace(' ', '_').toLowerCase()) != -1) {
                        temp.push(gameRates[item])
                    }
                })
            }
        }
    }, [starLineGameRateData, gameRates])

    // Remove submitBid - auto-add is handled in handleAutoInput

    console.log('inputValue', resultData)

    useEffect(() => {
        // Preserve points when resultData changes - don't clear autoInputValue as it's handled in handleAutoInput
        setFormData((prev: any) => ({
            ...prev,
            open: ''
        }))
        // Don't clear autoInputValue here - it's managed by handleAutoInput function
    }, [resultData])

    // Sync bulk digits when points changes (for game type 8 - starline always uses 'Open' session)
    // Note: gameidname is computed later, so we check gamename instead
    useEffect(() => {
        const currentGameId = gamename || '1';
        if (currentGameId === '8' && selectedBulkDigits.size > 0 && formData.points) {
            const updatedBids = Array.from(selectedBulkDigits).map((digit) => ({
                points: formData.points,
                session: 'Open',
                digits: digit,
                closedigits: '',
            }));
            setResultData(updatedBids);
        } else if (currentGameId === '8' && selectedBulkDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        }
    }, [formData.points, gamename, selectedBulkDigits])
    
    // Sync bulk pana digits when points changes (for game type 9 - Single Pana Bulk)
    useEffect(() => {
        const currentGameId = gamename || '1';
        if (currentGameId === '9' && selectedBulkPanaDigits.size > 0 && formData.points) {
            const allBids: any[] = [];
            selectedBulkPanaDigits.forEach((digit) => {
                const panaNumbers = singlePanaBulkMapping[digit] || [];
                panaNumbers.forEach((pana: string) => {
                    allBids.push({
                        points: formData.points,
                        session: 'Open',
                        digits: pana,
                        closedigits: '',
                    });
                });
            });
            setResultData(allBids);
        } else if (currentGameId === '9' && selectedBulkPanaDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        }
    }, [formData.points, gamename, selectedBulkPanaDigits])
    
    // Sync bulk double pana digits when points changes (for game type 10 - Double Pana Bulk)
    useEffect(() => {
        const currentGameId = gamename || '1';
        if (currentGameId === '10' && selectedBulkDoublePanaDigits.size > 0 && formData.points) {
            const allBids: any[] = [];
            selectedBulkDoublePanaDigits.forEach((digit) => {
                const panaNumbers = doublePanaBulkMapping[digit] || [];
                panaNumbers.forEach((pana: string) => {
                    allBids.push({
                        points: formData.points,
                        session: 'Open',
                        digits: pana,
                        closedigits: '',
                    });
                });
            });
            setResultData(allBids);
        } else if (currentGameId === '10' && selectedBulkDoublePanaDigits.size === 0) {
            // Clear resultData if no digits selected
            setResultData([]);
        }
    }, [formData.points, gamename, selectedBulkDoublePanaDigits])

    const removeBid = (i: any) => {
        const removedBid = resultData[i];
        const currentGameId = gamename || '1';
        const updatedBids = resultData.filter((item: any, index: number) => {
            return i != index
        })
        setResultData(updatedBids);
        
        // Update autoInputValue to reflect remaining bids (for game types 1, 3, 4, 5)
        if (currentGameId !== '8' && currentGameId !== '9' && currentGameId !== '10' && currentGameId !== '11' && currentGameId !== '12' && currentGameId !== '13') {
        const displayValue = updatedBids.map((bid: any) => bid.digits).join(',');
        setAutoInputValue(displayValue ? displayValue + ',' : '');
        }
        
        // Update selectedBulkDigits for game type 8 (bulk mode)
        if (currentGameId === '8' && removedBid) {
            setSelectedBulkDigits((prev) => {
                const newSet = new Set(prev);
                newSet.delete(removedBid.digits);
                return newSet;
            });
        }
        
        // Update selectedBulkPanaDigits for game type 9 (pana bulk mode)
        if (currentGameId === '9' && removedBid) {
            // Find which digit the removed pana belongs to
            const removedPana = removedBid.digits;
            for (const [digit, panaNumbers] of Object.entries(singlePanaBulkMapping)) {
                const panaArray = panaNumbers as string[];
                if (panaArray.includes(removedPana)) {
                    // Check if all pana numbers for this digit are removed
                    const remainingPanasForDigit = updatedBids.filter((bid: any) => panaArray.includes(bid.digits));
                    if (remainingPanasForDigit.length === 0) {
                        // All pana numbers for this digit are removed, so remove the digit from selection
                        setSelectedBulkPanaDigits((prev) => {
                            const newSet = new Set(prev);
                            newSet.delete(digit);
                            return newSet;
                        });
                    }
                    break;
                }
            }
        }
        
        // Update selectedBulkDoublePanaDigits for game type 10 (double pana bulk mode)
        if (currentGameId === '10' && removedBid) {
            // Find which digit the removed pana belongs to
            const removedPana = removedBid.digits;
            for (const [digit, panaNumbers] of Object.entries(doublePanaBulkMapping)) {
                const panaArray = panaNumbers as string[];
                if (panaArray.includes(removedPana)) {
                    // Check if all pana numbers for this digit are removed
                    const remainingPanasForDigit = updatedBids.filter((bid: any) => panaArray.includes(bid.digits));
                    if (remainingPanasForDigit.length === 0) {
                        // All pana numbers for this digit are removed, so remove the digit from selection
                        setSelectedBulkDoublePanaDigits((prev) => {
                            const newSet = new Set(prev);
                            newSet.delete(digit);
                            return newSet;
                        });
                    }
                    break;
                }
            }
        }
    }

    const submitGame = () => {
        const _homepagedata = starLineData.result.filter((item: any) => item.game_id == routeData.game_id)[0];
        
        // Determine actual pana type based on game type
        let actualPanaType = gameNameList[routeData.gamename];
        if (gameidname === '8') {
            actualPanaType = 'Single Digit';
        } else if (gameidname === '9' || gameidname === '12') {
            actualPanaType = 'Single Pana';
        } else if (gameidname === '10' || gameidname === '13') {
            actualPanaType = 'Double Pana';
        } else if (gameidname === '11') {
            // For game type 11, use the first bid's gameType (SP/DP/TP) to determine pana
            // This will be handled in submitGameFinal where we split by gameType
            actualPanaType = resultData[0]?.gameType === 'SP' ? 'Single Pana' : 
                            resultData[0]?.gameType === 'DP' ? 'Double Pana' : 
                            resultData[0]?.gameType === 'TP' ? 'Triple Pana' : 'Single Pana';
        }
        
        const payload: any = {
            app_key: "@34Y@#8deepmatka",
            new_result: {
                gameid: routeData.game_id,
                user_id: finalData.user_id,
                Gamename: _homepagedata.game_name,
                pana: actualPanaType,
                totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                session: 'Open',
                result: resultData,
                bid_date: date_from
            }
        }
        setPayload({
            gameid: routeData.game_id,
            user_id: finalData.user_id,
            Gamename: _homepagedata.game_name,
            pana: actualPanaType,
            totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
            session: 'Open',
            bid_date: date_from
        })
        handleModalOpen();
    }

    const submitGameFinal = () => {
        const _homepagedata = starLineData.result.filter((item: any) => item.game_id == routeData.game_id)[0];
        
        // For game type 11 (All SP DP TP), split resultData by gameType and send separate payloads
        if (gameidname === '11') {
            // Group bids by gameType (SP, DP, TP)
            const groupedBids: any = {
                'SP': [],
                'DP': [],
                'TP': []
            };
            
            resultData.forEach((bid: any) => {
                const gameType = bid.gameType || 'SP';
                if (groupedBids[gameType]) {
                    groupedBids[gameType].push(bid);
                }
            });
            
            // Send separate payloads for each gameType
            const payloadPromises: any[] = [];
            
            Object.keys(groupedBids).forEach((gameType) => {
                const bidsForType = groupedBids[gameType];
                if (bidsForType.length > 0) {
                    let panaType = 'Single Pana';
                    if (gameType === 'DP') panaType = 'Double Pana';
                    else if (gameType === 'TP') panaType = 'Triple Pana';
                    
                    const payload: any = {
                        app_key: "@34Y@#8deepmatka",
                        new_result: {
                            gameid: routeData.game_id,
                            user_id: finalData.user_id,
                            Gamename: _homepagedata.game_name,
                            pana: panaType,
                            totalbit: bidsForType.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                            session: 'Open',
                            result: bidsForType,
                            bid_date: date_from
                        }
                    };
                    
                    payloadPromises.push(dispatch(starlineActions.submitStarLineBidReq(payload)));
                }
            });
            
            // Wait for all payloads to be dispatched
            Promise.all(payloadPromises).then(() => {
                setResultData([]);
                handleModalClose();
            });
        } else {
            // For other game types, determine actual pana type
            let actualPanaType = gameNameList[routeData.gamename];
            if (gameidname === '8') {
                actualPanaType = 'Single Digit';
            } else if (gameidname === '9' || gameidname === '12') {
                actualPanaType = 'Single Pana';
            } else if (gameidname === '10' || gameidname === '13') {
                actualPanaType = 'Double Pana';
            }
            
            const payload: any = {
                app_key: "@34Y@#8deepmatka",
                new_result: {
                    gameid: routeData.game_id,
                    user_id: finalData.user_id,
                    Gamename: _homepagedata.game_name,
                    pana: actualPanaType,
                    totalbit: resultData.reduce((n: any, { points }: any) => parseInt(n) + parseInt(points), 0),
                    session: 'Open',
                    result: resultData,
                    bid_date: date_from
                }
            }

            dispatch(starlineActions.submitStarLineBidReq(payload))
            setResultData([]);
            handleModalClose();
        }
    }

    useEffect(() => {
        if (isSubmitStarLineBidSuccess) {
            setPayload({})
            setErrorMessage({ status: true, message: `${starLineMsg} redirecting to homepage.`, severity: "success", inputName: '' })
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getWalletBalanceReq(data))
            setTimeout(() => {
                navigate('/starline')
            }, 2000);
        }

        if (isSubmitStarLineBidFailed) {
            setPayload({})
            setErrorMessage({ status: true, message: starLineMsg, severity: "error", inputName: '' })
            const data: any = { "app_key": "@34Y@#8deepmatka", "user_id": finalData.user_id }
            dispatch(authActions.getWalletBalanceReq(data))
        }

        return (() => {
            dispatch(starlineActions.resetStarLIne())
        })
    }, [isSubmitStarLineBidSuccess, isSubmitStarLineBidFailed])

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setErrorMessage({ status: false, message: "", severity: "", inputName: '' })
    };


    const handleModalOpen = () => setOpen(true);
    const handleModalClose = () => setOpen(false);

    function checkTime(opentime: any, closetime: any, req: any) {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        var todayDate = mm + '/' + dd + '/' + yyyy;
        const startTimeHours = new Date(todayDate + ' ' + opentime).getHours();
        const startTimeMin = new Date(todayDate + ' ' + opentime).getMinutes()
        const endTimeHours = new Date(todayDate + ' ' + closetime).getHours();
        const endTimeMin = new Date(todayDate + ' ' + closetime).getMinutes()
        var currentD = today;
        var startHappyHourD = new Date();
        startHappyHourD.setHours(startTimeHours, startTimeMin, 0); // 10:00 pm
        var endHappyHourD = new Date();
        endHappyHourD.setHours(endTimeHours, endTimeMin, 0); // 10.00 pm

        if (req === 'open') {
            if (currentD >= startHappyHourD) {
                return true
            } else {
                return false
            }
        } else if (req === 'close') {
            if (currentD >= endHappyHourD) {
                return true
            } else {
                return false
            }
        }
    }
    const gameidname: any = gamename;
    return (
        <Container sx={{ 
            backgroundColor: theme.palette.background.default,
            minHeight: '100vh',
            paddingTop: { xs: '20px', sm: '25px', md: '30px' },
            paddingBottom: { xs: '80px', sm: '80px', md: '30px' },
        }}>
            {isStarLineLoading ? <div style={{ width: '100%', height: '30vh', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'row' }}> <CircularProgress sx={{ color: theme.palette.primary.main }} /> </div> :
                <Grid container gap={2}>
                    <AlertBar handleClose={handleClose} errorMessage={errorMessage} />
                    <Grid lg={6} md={6} sm={12} xs={12} sx={{ marginBottom: '50px' }} >
                        <Card sx={{
                            padding: { xs: '24px', sm: '28px', md: '32px' },
                            gap: '2',
                            boxShadow: '0 4px 20px rgba(74, 144, 226, 0.12)',
                            border: `1px solid ${theme.palette.divider}`,
                            borderRadius: '24px',
                            backgroundColor: theme.palette.background.paper,
                            position: 'relative',
                            overflow: 'hidden',
                            '&::before': {
                                content: '""',
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                height: '4px',
                                background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                opacity: 0.8,
                            },
                            transition: 'all 0.3s ease',
                        }}>
                            {/* Bulk Keypad Interface for Single Digit Bulk (Game Type 8) */}
                            {gameidname === '8' && (
                                <>
                                    {Object.keys(formFieldsBulk).map((item: any, index: number) => {
                                        return (
                                            <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                {(formFieldsBulk[item]['field'] === 'text') ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                        <TextField 
                                                            sx={{
                                                                width: "100%",
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }} 
                                                            name={item} 
                                                            variant="outlined" 
                                                            type="number"
                                                            value={formData[item]} 
                                                            onChange={(event: any) => handleChange(event, item)}
                                                            inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                        />
                                                    </> :
                                                    (formFieldsBulk[item]['field'] === 'date') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                            <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                        </> :
                                                        null
                                                }
                                            </FormControl>
                                        );
                                    })}
                                    
                                    {/* Keypad for Bulk Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digits (Click to toggle):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
                                                    <Grid item xs={4} key={digit}>
                                                        <Box
                                                            onClick={() => handleBulkDigitToggle(digit)}
                                                            sx={{
                                                                position: 'relative',
                                                                aspectRatio: '1',
                                                                borderRadius: '12px',
                                                                backgroundColor: selectedBulkDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.background.default,
                                                                color: selectedBulkDigits.has(digit) 
                                                                    ? '#FFFFFF' 
                                                                    : theme.palette.text.primary,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                border: `2px solid ${selectedBulkDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.divider}`,
                                                                boxShadow: selectedBulkDigits.has(digit) 
                                                                    ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                    : '0 2px 8px rgba(0,0,0,0.1)',
                                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                '&:hover': {
                                                                    transform: 'scale(1.05)',
                                                                    boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                },
                                                            }}
                                                        >
                                                            {selectedBulkDigits.has(digit) && (
                                                                <Typography sx={{
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points}
                                                                </Typography>
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '2rem',
                                                                fontWeight: 700,
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {digit}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkDigits.has('0') && (
                                                            <Typography sx={{
                                                                fontSize: '0.8rem',
                                                                fontWeight: 600,
                                                                marginBottom: '4px',
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {formData.points}
                                                            </Typography>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Bid
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* Bulk Keypad Interface for Single Pana Bulk (Game Type 9) */}
                            {gameidname === '9' && (
                                <>
                                    {Object.keys(formFieldsBulk).map((item: any, index: number) => {
                                        return (
                                            <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                {(formFieldsBulk[item]['field'] === 'text') ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                        <TextField 
                                                            sx={{
                                                                width: "100%",
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }} 
                                                            name={item} 
                                                            variant="outlined" 
                                                            type="number"
                                                            value={formData[item]} 
                                                            onChange={(event: any) => handleChange(event, item)}
                                                            inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                        />
                                                    </> :
                                                    (formFieldsBulk[item]['field'] === 'date') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                            <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                        </> :
                                                        null
                                                }
                                            </FormControl>
                                        );
                                    })}
                                    
                                    {/* Keypad for Bulk Pana Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digit (Click to toggle - will add all SP Panas for that digit):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
                                                    <Grid item xs={4} key={digit}>
                                                        <Box
                                                            onClick={() => handleBulkPanaDigitToggle(digit)}
                                                            sx={{
                                                                position: 'relative',
                                                                aspectRatio: '1',
                                                                borderRadius: '12px',
                                                                backgroundColor: selectedBulkPanaDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.background.default,
                                                                color: selectedBulkPanaDigits.has(digit) 
                                                                    ? '#FFFFFF' 
                                                                    : theme.palette.text.primary,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                border: `2px solid ${selectedBulkPanaDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.divider}`,
                                                                boxShadow: selectedBulkPanaDigits.has(digit) 
                                                                    ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                    : '0 2px 8px rgba(0,0,0,0.1)',
                                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                '&:hover': {
                                                                    transform: 'scale(1.05)',
                                                                    boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                },
                                                            }}
                                                        >
                                                            {selectedBulkPanaDigits.has(digit) && (
                                                                <Typography sx={{
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points} × {(singlePanaBulkMapping[digit] || []).length}
                                                                </Typography>
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '2rem',
                                                                fontWeight: 700,
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {digit}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkPanaDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkPanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkPanaDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkPanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkPanaDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkPanaDigits.has('0') && (
                                                            <Typography sx={{
                                                                fontSize: '0.8rem',
                                                                fontWeight: 600,
                                                                marginBottom: '4px',
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {formData.points} × {(singlePanaBulkMapping['0'] || []).length}
                                                            </Typography>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total Panas
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total Points
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* Bulk Keypad Interface for Double Pana Bulk (Game Type 10) */}
                            {gameidname === '10' && (
                                <>
                                    {Object.keys(formFieldsBulk).map((item: any, index: number) => {
                                        return (
                                            <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                {(formFieldsBulk[item]['field'] === 'text') ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                        <TextField 
                                                            sx={{
                                                                width: "100%",
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }} 
                                                            name={item} 
                                                            variant="outlined" 
                                                            type="number"
                                                            value={formData[item]} 
                                                            onChange={(event: any) => handleChange(event, item)}
                                                            inputProps={{ min: outletdata?.walletBalance?.min_bid_amount || 10 }}
                                                        />
                                                    </> :
                                                    (formFieldsBulk[item]['field'] === 'date') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsBulk[item]['label']}</FormLabel>
                                                            <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                        </> :
                                                        null
                                                }
                                            </FormControl>
                                        );
                                    })}
                                    
                                    {/* Keypad for Bulk Double Pana Selection */}
                                    {formData.points && (
                                        <Box sx={{ marginTop: '25px' }}>
                                            <Typography sx={{
                                                color: theme.palette.text.primary,
                                                fontFamily: 'Poppins',
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                marginBottom: '15px',
                                            }}>
                                                Select Digit (Click to toggle - will add all DP Panas for that digit):
                                            </Typography>
                                            
                                            <Grid container spacing={2}>
                                                {/* Digits 1-9 in 3x3 grid */}
                                                {['1', '2', '3', '4', '5', '6', '7', '8', '9'].map((digit) => (
                                                    <Grid item xs={4} key={digit}>
                                                        <Box
                                                            onClick={() => handleBulkDoublePanaDigitToggle(digit)}
                                                            sx={{
                                                                position: 'relative',
                                                                aspectRatio: '1',
                                                                borderRadius: '12px',
                                                                backgroundColor: selectedBulkDoublePanaDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.background.default,
                                                                color: selectedBulkDoublePanaDigits.has(digit) 
                                                                    ? '#FFFFFF' 
                                                                    : theme.palette.text.primary,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                cursor: 'pointer',
                                                                border: `2px solid ${selectedBulkDoublePanaDigits.has(digit) 
                                                                    ? theme.palette.primary.main 
                                                                    : theme.palette.divider}`,
                                                                boxShadow: selectedBulkDoublePanaDigits.has(digit) 
                                                                    ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                    : '0 2px 8px rgba(0,0,0,0.1)',
                                                                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                                '&:hover': {
                                                                    transform: 'scale(1.05)',
                                                                    boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                                },
                                                            }}
                                                        >
                                                            {selectedBulkDoublePanaDigits.has(digit) && (
                                                                <Typography sx={{
                                                                    fontSize: '0.7rem',
                                                                    fontWeight: 600,
                                                                    marginBottom: '4px',
                                                                    fontFamily: 'Poppins',
                                                                }}>
                                                                    {formData.points} × {(doublePanaBulkMapping[digit] || []).length}
                                                                </Typography>
                                                            )}
                                                            <Typography sx={{
                                                                fontSize: '2rem',
                                                                fontWeight: 700,
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {digit}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                                ))}
                                                
                                                {/* Digit 0 - Full width at bottom */}
                                                <Grid item xs={12}>
                                                    <Box
                                                        onClick={() => handleBulkDoublePanaDigitToggle('0')}
                                                        sx={{
                                                            position: 'relative',
                                                            height: '80px',
                                                            borderRadius: '12px',
                                                            backgroundColor: selectedBulkDoublePanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.background.default,
                                                            color: selectedBulkDoublePanaDigits.has('0') 
                                                                ? '#FFFFFF' 
                                                                : theme.palette.text.primary,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            cursor: 'pointer',
                                                            border: `2px solid ${selectedBulkDoublePanaDigits.has('0') 
                                                                ? theme.palette.primary.main 
                                                                : theme.palette.divider}`,
                                                            boxShadow: selectedBulkDoublePanaDigits.has('0') 
                                                                ? `0 4px 15px ${theme.palette.primary.main}40` 
                                                                : '0 2px 8px rgba(0,0,0,0.1)',
                                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                                            '&:hover': {
                                                                transform: 'scale(1.02)',
                                                                boxShadow: `0 6px 20px ${theme.palette.primary.main}60`,
                                                            },
                                                        }}
                                                    >
                                                        {selectedBulkDoublePanaDigits.has('0') && (
                                                            <Typography sx={{
                                                                fontSize: '0.8rem',
                                                                fontWeight: 600,
                                                                marginBottom: '4px',
                                                                fontFamily: 'Poppins',
                                                            }}>
                                                                {formData.points} × {(doublePanaBulkMapping['0'] || []).length}
                                                            </Typography>
                                                        )}
                                                        <Typography sx={{
                                                            fontSize: '2rem',
                                                            fontWeight: 700,
                                                            fontFamily: 'Poppins',
                                                        }}>
                                                            0
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            
                                            {/* Summary Box */}
                                            {resultData.length > 0 && (
                                                <Box sx={{
                                                    marginTop: '20px',
                                                    padding: '15px',
                                                    borderRadius: '12px',
                                                    backgroundColor: theme.palette.mode === 'light' 
                                                        ? 'rgba(74, 144, 226, 0.1)' 
                                                        : 'rgba(74, 144, 226, 0.2)',
                                                    border: `1px solid ${theme.palette.primary.light}`,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                }}>
                                                    <Box>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total Panas
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.length}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ textAlign: 'right' }}>
                                                        <Typography sx={{
                                                            fontSize: '0.85rem',
                                                            color: theme.palette.text.secondary,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 500,
                                                        }}>
                                                            Total Points
                                                        </Typography>
                                                        <Typography sx={{
                                                            fontSize: '1.5rem',
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 700,
                                                        }}>
                                                            {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            )}
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* All SP DP TP Interface (Game Type 11) */}
                            {gameidname === '11' && (
                                <>
                                    {Object.keys(formFieldsAllSPDPTP).map((item: any, index: number) => {
                                        return (
                                            <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                {(formFieldsAllSPDPTP[item]['field'] === 'text') ?
                                                    <>
                                                        <FormLabel sx={{ 
                                                            color: theme.palette.primary.main, 
                                                            marginBottom: '5px',
                                                            fontFamily: 'Poppins',
                                                            fontWeight: 600,
                                                            fontSize: '0.95rem',
                                                        }}>{formFieldsAllSPDPTP[item]['label']}</FormLabel>
                                                        <TextField 
                                                            sx={{
                                                                width: "100%",
                                                                '& .MuiOutlinedInput-root': {
                                                                    '& fieldset': {
                                                                        borderColor: theme.palette.divider,
                                                                    },
                                                                    '&:hover fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                    },
                                                                    '&.Mui-focused fieldset': {
                                                                        borderColor: theme.palette.primary.main,
                                                                        borderWidth: '2px',
                                                                    },
                                                                },
                                                            }} 
                                                            name={item} 
                                                            variant="outlined" 
                                                            type={item === 'points' ? 'number' : 'text'}
                                                            value={formData[item]} 
                                                            onChange={(event: any) => handleChange(event, item)}
                                                            inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digit' ? { maxLength: 1, pattern: '[0-9]' } : {})}
                                                            placeholder={formFieldsAllSPDPTP[item]['placeholder']}
                                                        />
                                                    </> :
                                                    (formFieldsAllSPDPTP[item]['field'] === 'date') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsAllSPDPTP[item]['label']}</FormLabel>
                                                            <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                        </> :
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name="row-radio-buttons-group"
                                                            sx={{ marginTop: '10px' }}
                                                            value={selectedPanaType}
                                                            onChange={(e) => {
                                                                setSelectedPanaType(e.target.value);
                                                            }}
                                                        >
                                                            {formFieldsAllSPDPTP[item]['value'] && formFieldsAllSPDPTP[item]['value'].map((keys: any) => (
                                                                <FormControlLabel 
                                                                    sx={{ 
                                                                        color: theme.palette.primary.main,
                                                                        fontFamily: 'Poppins',
                                                                    }} 
                                                                    value={keys} 
                                                                    control={<Radio 
                                                                        checked={selectedPanaType === keys} 
                                                                        sx={{
                                                                            color: theme.palette.primary.main,
                                                                            '&.Mui-checked': {
                                                                                color: theme.palette.primary.main,
                                                                            },
                                                                        }}
                                                                    />} 
                                                                    label={keys} 
                                                                />
                                                            ))}
                                                        </RadioGroup>
                                                }
                                            </FormControl>
                                        );
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidAllSPDPTP}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* SP Motor Interface (Game Type 12) */}
                            {gameidname === '12' && (
                                <>
                                    {Object.keys(formFieldsSPMotor).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'points' || item === 'digits') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(formFieldsSPMotor[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsSPMotor[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type={item === 'points' ? 'number' : 'text'}
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digits' ? { pattern: '[0-9]*' } : {})}
                                                                placeholder={formFieldsSPMotor[item]['placeholder']}
                                                            />
                                                        </> :
                                                        (formFieldsSPMotor[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{formFieldsSPMotor[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            null
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidSPMotor}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {/* DP Motor Interface (Game Type 13) */}
                            {gameidname === '13' && (
                                <>
                                    {Object.keys(formFieldsDPMotor).map((item: any, index: number) => {
                                        if (item === 'date' || item === 'points' || item === 'digits') {
                                            return (
                                                <FormControl key={`${item}-${index}`} sx={{ display: 'flex', color: theme.palette.primary.main, marginTop: index > 0 ? '15px' : '5px' }}>
                                                    {(formFieldsDPMotor[item]['field'] === 'text') ?
                                                        <>
                                                            <FormLabel sx={{ 
                                                                color: theme.palette.primary.main, 
                                                                marginBottom: '5px',
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 600,
                                                                fontSize: '0.95rem',
                                                            }}>{formFieldsDPMotor[item]['label']}</FormLabel>
                                                            <TextField 
                                                                sx={{
                                                                    width: "100%",
                                                                    '& .MuiOutlinedInput-root': {
                                                                        '& fieldset': {
                                                                            borderColor: theme.palette.divider,
                                                                        },
                                                                        '&:hover fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                        },
                                                                        '&.Mui-focused fieldset': {
                                                                            borderColor: theme.palette.primary.main,
                                                                            borderWidth: '2px',
                                                                        },
                                                                    },
                                                                }} 
                                                                name={item} 
                                                                variant="outlined" 
                                                                type={item === 'points' ? 'number' : 'text'}
                                                                value={formData[item]} 
                                                                onChange={(event: any) => handleChange(event, item)}
                                                                inputProps={item === 'points' ? { min: outletdata?.walletBalance?.min_bid_amount || 10 } : (item === 'digits' ? { pattern: '[0-9]*' } : {})}
                                                                placeholder={formFieldsDPMotor[item]['placeholder']}
                                                            />
                                                        </> :
                                                        (formFieldsDPMotor[item]['field'] === 'date') ?
                                                            <>
                                                                <FormLabel sx={{ 
                                                                    color: theme.palette.primary.main, 
                                                                    marginBottom: '5px',
                                                                    fontFamily: 'Poppins',
                                                                    fontWeight: 600,
                                                                    fontSize: '0.95rem',
                                                                }}>{formFieldsDPMotor[item]['label']}</FormLabel>
                                                                <MobileDatePicker sx={{ width: '100%' }} name="date_from" disabled={true} value={date_from} />
                                                            </> :
                                                            null
                                                    }
                                                </FormControl>
                                            );
                                        }
                                        return null;
                                    })}
                                    
                                    {/* ADD BID Button */}
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px', 
                                            background: `linear-gradient(135deg, ${theme.palette.warning.main || '#FF9800'} 0%, ${theme.palette.error.main || '#F44336'} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(255, 152, 0, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.warning.dark || '#F57C00'} 0%, ${theme.palette.error.dark || '#D32F2F'} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(255, 152, 0, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                            width: '100%',
                                        }} 
                                        onClick={handleAddBidDPMotor}
                                    >
                                        ADD BID
                                    </Button>
                                    
                                    {/* Summary Box */}
                                    {resultData.length > 0 && (
                                        <Box sx={{
                                            marginTop: '20px',
                                            padding: '15px',
                                            borderRadius: '12px',
                                            backgroundColor: theme.palette.mode === 'light' 
                                                ? 'rgba(74, 144, 226, 0.1)' 
                                                : 'rgba(74, 144, 226, 0.2)',
                                            border: `1px solid ${theme.palette.primary.light}`,
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}>
                                            <Box>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Bid
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.length}
                                                </Typography>
                                            </Box>
                                            <Box sx={{ textAlign: 'right' }}>
                                                <Typography sx={{
                                                    fontSize: '0.85rem',
                                                    color: theme.palette.text.secondary,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 500,
                                                }}>
                                                    Total
                                                </Typography>
                                                <Typography sx={{
                                                    fontSize: '1.5rem',
                                                    color: theme.palette.primary.main,
                                                    fontFamily: 'Poppins',
                                                    fontWeight: 700,
                                                }}>
                                                    {resultData.reduce((sum: number, bid: any) => sum + parseInt(bid.points), 0)}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    )}
                                </>
                            )}
                            
                            {Object.keys(formFields).map((item: any, index: number) => {
                                // Skip fields for bulk mode, game type 11, 12, and 13 (already rendered above)
                                if ((gameidname === '8' || gameidname === '9' || gameidname === '10' || gameidname === '11' || gameidname === '12' || gameidname === '13') && (item === 'date' || item === 'points')) {
                                    return null;
                                }
                                // Show TextField for auto-input (game types 1, 3, 4, 5) instead of Autocomplete
                                const shouldShowAutoInput = (gameidname === '1' || gameidname === '3' || gameidname === '4' || gameidname === '5') &&
                                    formFields[item]['field'] === 'autocomplete' &&
                                    item === 'open';
                                
                                return (
                                    <FormControl sx={{ display: 'flex', color: theme.palette.primary.main }} key={item}>
                                        <FormLabel sx={{ 
                                            color: theme.palette.primary.main, 
                                            marginTop: (index > 0) ? '15px' : '5px', 
                                            marginBottom: '5px',
                                            fontFamily: 'Poppins',
                                            fontWeight: 600,
                                            fontSize: '0.95rem',
                                        }}>
                                            {formFields[item]['field'] === 'autocomplete' && shouldShowAutoInput 
                                                ? `Enter ${gameNameList[gameidname] || 'Digits'}` 
                                                : formFields[item]['label']}
                                        </FormLabel>
                                        {(formFields[item]['field'] === 'text') ? <TextField sx={{
                                            width: "100%",
                                            '& .MuiOutlinedInput-root': {
                                                '& fieldset': {
                                                    borderColor: theme.palette.divider,
                                                },
                                                '&:hover fieldset': {
                                                    borderColor: theme.palette.primary.main,
                                                },
                                                '&.Mui-focused fieldset': {
                                                    borderColor: theme.palette.primary.main,
                                                    borderWidth: '2px',
                                                },
                                            },
                                            '& .MuiInputLabel-root.Mui-focused': {
                                                color: theme.palette.primary.main,
                                            },
                                        }}
                                            name={item} variant="outlined" value={formData[item]} onChange={(event: any) => handleChange(event, item)} /> :
                                            (formFields[item]['field'] === 'date') ? <MobileDatePicker sx={{ 
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: theme.palette.divider,
                                                    },
                                                },
                                            }} name="date_from" disabled={true} value={date_from} /> : 
                                            (shouldShowAutoInput) ? <TextField
                                                sx={{ 
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        '& fieldset': {
                                                            borderColor: theme.palette.divider,
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: theme.palette.primary.main,
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            borderColor: theme.palette.primary.main,
                                                            borderWidth: '2px',
                                                        },
                                                    },
                                                    '& input': {
                                                        fontSize: '18px',
                                                        letterSpacing: '2px',
                                                        fontFamily: 'Poppins',
                                                    },
                                                }}
                                                variant="outlined"
                                                value={autoInputValue}
                                                onChange={handleAutoInput}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9,]/.test(event.key)) {
                                                        event.preventDefault();
                                                    }
                                                }}
                                                inputProps={{
                                                    inputMode: 'numeric',
                                                    pattern: '[0-9,]*'
                                                }}
                                                placeholder={`Enter ${gameNameList[gameidname] || 'digits'} (e.g., 1,2,3 or 123,456)`}
                                            /> :
                                            <RadioGroup
                                                row
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                {formFields[item]['value'] && formFields[item]['value'].map((keys: any) => (
                                                    <FormControlLabel 
                                                        sx={{ 
                                                            color: theme.palette.primary.main,
                                                            fontFamily: 'Poppins',
                                                            '& .MuiFormControlLabel-label': {
                                                                fontFamily: 'Poppins',
                                                                fontWeight: 500,
                                                            },
                                                        }} 
                                                        disabled={(checkTime(statusData.open_time, statusData.close_time, 'open') && keys === 'Open')} 
                                                        value={keys} 
                                                        control={<Radio 
                                                            checked={formData[item] === keys} 
                                                            onChange={(event: any) => handleChange(event, item)}
                                                            sx={{
                                                                color: theme.palette.primary.main,
                                                                '&.Mui-checked': {
                                                                    color: theme.palette.primary.main,
                                                                },
                                                            }}
                                                        />} 
                                                        label={keys} 
                                                    />))
                                                }

                                            </RadioGroup>
                                        }
                                    </FormControl>
                                )
                            })}
                            {/* Clear button for bulk mode (game type 8) */}
                            {(gameidname === '8' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Digits
                                </Button>
                            )}
                            
                            {/* Clear button for bulk mode (game type 9) */}
                            {(gameidname === '9' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkPanaDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Panas
                                </Button>
                            )}
                            
                            {/* Clear button for bulk mode (game type 10) */}
                            {(gameidname === '10' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setSelectedBulkDoublePanaDigits(new Set());
                                    }}
                                >
                                    🗑️ Clear All Selected Double Panas
                                </Button>
                            )}
                            
                            {/* Clear button for game type 11 (All SP DP TP) */}
                            {(gameidname === '11' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digit: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            
                            {/* Clear button for game type 12 (SP Motor) */}
                            {(gameidname === '12' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digits: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            
                            {/* Clear button for game type 13 (DP Motor) */}
                            {(gameidname === '13' && resultData.length > 0) && (
                                <Button 
                                    variant="outlined" 
                                    color="error"
                                    sx={{ marginTop: '15px' }}
                                    onClick={() => {
                                        setResultData([]);
                                        setFormData((prev: any) => ({ ...prev, digits: '' }));
                                    }}
                                >
                                    🗑️ Clear All Bids
                                </Button>
                            )}
                            {resultData.length ?
                                <>
                                    <List sx={{ width: '100%' }}>
                                        {resultData.map((item: any, index: number) => (
                                            <>
                                                <ListItem 
                                                    disablePadding
                                                    sx={{
                                                        animation: 'fadeIn 0.3s ease-in-out',
                                                        '@keyframes fadeIn': {
                                                            from: { opacity: 0, transform: 'translateY(-10px)' },
                                                            to: { opacity: 1, transform: 'translateY(0)' },
                                                        },
                                                    }}
                                                >
                                                    <ListItemButton 
                                                        sx={{ 
                                                            paddingLeft: '0px', 
                                                            paddingRight: '0px', 
                                                            padding: 0,
                                                            '&:hover': {
                                                                backgroundColor: 'rgba(74, 144, 226, 0.05)',
                                                            },
                                                            transition: 'background-color 0.2s ease',
                                                        }}
                                                    >
                                                        <ListItemText sx={{ alignItems: 'center' }}>
                                                            <Grid container>
                                                                <Grid lg={10} md={10} xs={10} sm={10} sx={{ display: 'flex', alignItems: 'center' }}>
                                                                    <Box sx={{ 
                                                                        display: 'flex', 
                                                                        flexDirection: 'row', 
                                                                        color: theme.palette.text.primary, 
                                                                        justifyContent: 'flex-start', 
                                                                        alignItems: 'center',
                                                                        fontFamily: 'Poppins',
                                                                    }}>
                                                                        <Typography sx={{ 
                                                                            fontSize: '0.9rem',
                                                                            fontFamily: 'Poppins',
                                                                            fontWeight: 600,
                                                                            color: theme.palette.primary.main,
                                                                        }}>
                                                                            Points: {item.points}
                                                                        </Typography>
                                                                        <Divider orientation="vertical" flexItem sx={{ 
                                                                            height: '18px', 
                                                                            marginLeft: '10px', 
                                                                            marginRight: '10px',
                                                                            borderColor: theme.palette.divider,
                                                                        }} />
                                                                        <Typography sx={{ 
                                                                            fontSize: '0.9rem',
                                                                            fontFamily: 'Poppins',
                                                                            fontWeight: 500,
                                                                            color: theme.palette.text.primary,
                                                                        }}>
                                                                            {gameidname === '11' && item.gameType ? `${item.gameType}: ` : ''}Digit: {item.digits}
                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                                <Grid lg={2} md={2} xs={2} sm={2} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}><IconButton>
                                                                    <IconButton 
                                                                        sx={{
                                                                            color: theme.palette.error.main,
                                                                            '&:hover': {
                                                                                backgroundColor: 'rgba(255, 107, 107, 0.1)',
                                                                                transform: 'scale(1.1)',
                                                                            },
                                                                            transition: 'all 0.2s ease',
                                                                        }}
                                                                        onClick={() => removeBid(index)}
                                                                    >
                                                                        <Close />
                                                                    </IconButton>
                                                                </IconButton></Grid>
                                                            </Grid>
                                                        </ListItemText>
                                                    </ListItemButton>
                                                </ListItem>
                                                <Divider sx={{ borderColor: theme.palette.divider }} />
                                            </>
                                        ))}
                                    </List>
                                    <Button 
                                        variant="contained" 
                                        sx={{ 
                                            marginTop: '15px',
                                            background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                            color: '#FFFFFF',
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                            '&:hover': { 
                                                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                                transform: 'translateY(-2px)',
                                                boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                            },
                                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                        }} 
                                        onClick={submitGame}
                                    >
                                        Play Game
                                    </Button>

                                </> : ''
                            }
                        </Card>
                    </Grid>
                    <CustomModal 
                        open={open} 
                        handleClose={handleModalClose} 
                        customstyle={{ 
                            width: {xs:'300px', lg:'400px', sm:'300px', md:'350px'}, 
                            backgroundColor: theme.palette.background.paper, 
                            padding: '24px',
                            borderRadius: '20px',
                            boxShadow: '0 8px 32px rgba(74, 144, 226, 0.2)',
                            border: `1px solid ${theme.palette.divider}`,
                        }}
                    >
                        <Box>
                            <List sx={{ width: '100%' }}>

                                {/* <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemText>
                                    <Grid container>
                                        <Grid lg={8}>
                                            <Typography>Session</Typography>
                                        </Grid>
                                        <Grid lg={4}>
                                            <Typography>{payloadData['session']}</Typography>
                                        </Grid>
                                    </Grid>
                                </ListItemText>
                            </ListItemButton>
                        </ListItem>
                        <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} /> */}
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={12} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Total Points:
                                                    </Typography>
                                                    <Typography sx={{
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.primary.main,
                                                    }}>
                                                        {payloadData['totalbit']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                                <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={12} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Wallet Balance:
                                                    </Typography>
                                                    <Typography sx={{
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.success.main,
                                                    }}>
                                                        {outletdata['walletBalance']['wallet_amt']}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>
                                <Divider sx={{ borderColor: theme.palette.divider, my: 1 }} />
                                <ListItem disablePadding>
                                    <ListItemButton sx={{ paddingLeft: '0px', paddingRight: '0px', padding: 0 }}>
                                        <ListItemText>
                                            <Grid container>
                                                <Grid lg={12} display={'flex'}>
                                                    <Typography sx={{ 
                                                        fontFamily: 'Poppins',
                                                        fontWeight: 500,
                                                        color: theme.palette.text.secondary,
                                                    }}>
                                                        Remaining Balance (After bid):
                                                    </Typography>
                                                    <Typography sx={{
                                                        marginLeft: '10px', 
                                                        fontWeight: 600,
                                                        fontFamily: 'Poppins',
                                                        color: theme.palette.warning.main,
                                                    }}>
                                                        {parseInt(outletdata['walletBalance']['wallet_amt']) - parseInt(payloadData['totalbit'])}
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </ListItemText>
                                    </ListItemButton>
                                </ListItem>

                            </List>
                            <Button 
                                variant="contained" 
                                sx={{ 
                                    marginTop: '15px',
                                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                                    color: '#FFFFFF',
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 15px rgba(74, 144, 226, 0.3)',
                                    '&:hover': { 
                                        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.secondary.dark} 100%)`,
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }} 
                                onClick={submitGameFinal}
                            >
                                Submit Game
                            </Button>
                            <Button 
                                variant="outlined" 
                                sx={{ 
                                    marginTop: '15px', 
                                    marginLeft: '10px',
                                    borderColor: theme.palette.divider,
                                    color: theme.palette.text.primary,
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    padding: '12px 24px',
                                    borderRadius: '12px',
                                    '&:hover': {
                                        borderColor: theme.palette.error.main,
                                        backgroundColor: 'rgba(255, 107, 107, 0.05)',
                                        transform: 'translateY(-2px)',
                                    },
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                }} 
                                onClick={handleModalClose}
                            >
                                Cancel
                            </Button>
                        </Box>
                    </CustomModal>
                </Grid>
            }
        </Container>
    )
}

const mapStateToProps = (state: any) => ({
    isStarLineLoading: state.starline.isStarLineLoading,
    starLineData: state.starline.starLineData,
    starLineMsg: state.starline.starLineMsg,
    starLineGameRateData: state.starline.starLineGameRateData,
    isStarLineGameRateFailed: state.starline.isStarLineGameRateFailed,
    starLineGameStatusActiveInactiveData: state.starline.starLineGameStatusActiveInactiveData,
    isStarLineGameStatusActiveInactiveFailed: state.starline.isStarLineGameStatusActiveInactiveFailed,
    isStarLineGameStatusActiveInactiveSuccess: state.starline.isStarLineGameStatusActiveInactiveSuccess,
    isSubmitStarLineBidSuccess: state.starline.isSubmitStarLineBidSuccess,
    isSubmitStarLineBidFailed: state.starline.isSubmitStarLineBidFailed,
})


export default connect(mapStateToProps)(StarLinePlaceBid);